var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroadcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5E7F\u64AD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7CFB\\u7EDFUI\\u754C\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-1106.000000, -121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pageheader\\u5907\\u4EFD",
    transform: "translate(208.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3\\u5907\\u4EFD",
    transform: "translate(887.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5E7F\\u64AD",
    transform: "translate(11.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L16,0 L16,16 L0,16 L0,0 Z",
    id: "sound-(Background)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74241474,13.1633282 C9.07567671,13.363286 9.49966267,13.12323 9.49966267,12.7345819 L9.49966267,2.500772 C9.49966267,2.11212477 9.07567671,1.87206845 8.74241426,2.07202582 L4.49966267,4.61767673 L2.60448441,4.61767673 C2.2733331,4.61767673 2.00479391,4.88596368 2.00448456,5.21711636 L2.00000027,10.0171156 C1.99969074,10.3487053 2.26841006,10.6176767 2.60000029,10.6176767 L4.49966267,10.6176767 L8.74241474,13.1633282 Z M5.49966293,10.051487 L8.49966293,11.8514872 L8.49966293,3.38386714 L5.49966293,5.18386722 L5.49966293,10.051487 Z M4.49966293,5.61767673 L3.00411111,5.61767673 L3.00037437,9.61767673 L4.49966293,9.61767673 L4.49966293,5.61767673 Z M13.8260195,6.90886024 C14.1381487,6.90890957 14.3911541,7.17010588 14.3911541,7.49229081 C14.3911541,7.81447574 14.1381487,8.07567206 13.8260195,8.07572138 L11.5651349,8.07572138 C11.2530057,8.07567206 11.0000003,7.81447574 11.0000003,7.49229081 C11.0000003,7.17010588 11.2530057,6.90890957 11.5651349,6.90886024 L13.8260195,6.90886024 L13.8260195,6.90886024 Z M13.8944113,2.17082057 C14.1152196,2.39848902 14.1154726,2.76780081 13.8949765,2.9957914 L12.2954006,4.64573305 C12.0727913,4.8612075 11.7246715,4.85537251 11.5089573,4.63255111 C11.293243,4.40972972 11.2878364,4.05039072 11.4967431,3.82076222 L13.0951886,2.17082057 C13.3159073,1.94305981 13.6736925,1.94305981 13.8944113,2.17082057 L13.8944113,2.17082057 Z M13.8944113,12.6327598 C14.1152196,12.4050914 14.1154726,12.0357796 13.8949765,11.807789 L12.2954006,10.1578473 C12.0727913,9.94237287 11.7246715,9.94820787 11.5089573,10.1710293 C11.293243,10.3938507 11.2878364,10.7531896 11.4967431,10.9828182 L13.0951886,12.6327598 C13.3159073,12.8605206 13.6736925,12.8605206 13.8944113,12.6327598 L13.8944113,12.6327598 Z",
    id: "sound",
    fill: "currentColor"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.1265fb248256063a7ee9d84e7014cb0b.svg";
export { ForwardRef as ReactComponent };